import { IPagination, IPaginationDTO } from './pagination.model';
import { ImportType } from './productsImport.model';

export enum FiltersEndpoints {
  FILTERS = '/filters',
  FILTERS_IMPORT = '/products/import/filters',
  MARKETPLACE_ATTRIBUTES = '/marketplace/attributes',
}

export enum SortDirections {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

export enum FilterImportStatus {
  PROCESSING = 'Processing',
  FINISHED = 'Finished',
  FAILED = 'Failed',
}

export interface IFilterImport {
  author: string;
  created_at: string;
  error_count: number;
  error_message: string;
  errors_url: string;
  id: string;
  partner: string;
  progress_count: number;
  status: FilterImportStatus;
  store: string;
  total_count: number;
  type: ImportType;
  updated_at: string;
}

// ----------------- DTOs ----------------

export interface IFilterCategoryItem {
  active: boolean;
  id: string;
  name: string;
  position: number;
}

export interface ICreateFilterDTO {
  position: number;
  locale: IFilterLocale;
  type: FilterType;
  is_active: boolean;
  required: boolean;
  filterable: boolean;
  slug?: string;
  categories?: string[];
}

export interface IGetFiltersDTO extends Partial<IPaginationDTO> {
  title?: string;
  type?: FilterType;
  slug?: string;
  is_active?: number;
  categories?: string[];
}

export interface IGetFilterValuesDTO extends IPaginationDTO {
  slug?: string;
  title?: string;
  filter_id: string;
}

export interface IDeleteFilterValueDTO {
  id: string;
  filter_id: string;
}

export interface IEditFilterValueDTO {
  id?: string;
  filter_id: string;
  data: IFilterValue;
}

export interface IGetFiltersListDTO {
  title?: string;
  limit?: number;
  page?: number;
}

export interface ICreateFilterValueDTO {
  filter_id: string;
  data: IFilterValue;
}

export interface IImportSFiltersDTO {
  filter_id: string;
  file?: File;
}

// ------------ Responses --------------

export interface IFilter {
  id: string;
  position: number;
  type: string;
  slug: string;
  is_active: boolean;
  required: boolean;
  filterable: boolean;
  values: IFilterValue[];
  locale: IFilterLocale;
  categories: IFilterCategoryItem[];
  marketplace_mappings?: IFilterMarketplaceMapping[];
  latest_filter_value_import: IFilterImport;
}

export interface IFilterMarketplaceMapping {
  marketplace: string;
  external_id: string;
  name?: string;
  category_external_id?: string | null;
  matched_by: 'exact' | 'normalized' | 'synonym' | 'path' | 'inherited' | 'manual' | 'ai';
}

export interface IMarketplaceAttribute {
  marketplace: string;
  external_id: string;
  name: string;
  count?: number;
  external_ids?: string[];
  category_external_id?: string | null;
  category_external_ids?: string[];
}

export interface IMarketplaceAttributesResponse {
  data: IMarketplaceAttribute[];
}

export interface IUpdateFilterMarketplaceMappingsDTO {
  marketplace: string;
  external_ids: string[];
}

export interface IUpdateFilterMarketplaceMappingsResponse {
  data: IFilterMarketplaceMapping[];
}

export interface IFilterLocale {
  uk: {
    title: string;
  };
  ru: {
    title: string;
  };
}

export interface IFilterValueLocale {
  uk: {
    title: string;
  } | null;
  ru: {
    title: string;
  } | null;
}

export interface IFilterValue {
  id?: string;
  slug: string;
  locale: IFilterValueLocale;
}

export interface IFilterValuesResponse {
  data: IFilterValue[];
  meta: IPagination;
}

export interface IFiltersResponse {
  data: IFilter[];
  meta: IPagination;
}

export enum FilterType {
  RADIO_BUTTON = 'radio_button',
  MULTISELECT = 'multiselect',
  MULTISELECT_WITH_SEARCH = 'multiselect_with_search',
  SLIDER = 'slider',
}

export interface IFilterDetailsResponse {
  data: IFilter;
}

export interface IFilterDetailsResponse {
  data: IFilter;
}

export interface IFilterDetailsResponse {
  data: IFilter;
}
